<script setup lang="ts">
import {computed, onMounted, ref} from 'vue';
import {Icon} from '@iconify/vue';
import {useFileHistoryStore} from '@/stores/useFileHistoryStore';
import {useOsmdRenderer} from '@/composables/useOsmdRenderer';

const {entryId} = defineProps<{
  entryId: string;
}>();

const historyStore = useFileHistoryStore();

const isLoading = ref(true);
const previewXml = ref<string | null>(null);

// Vorschau-Rendering ausschließlich über den OSMD-Composable (VUE_RULES.md).
const {containerRef, isRendering, error: renderError} = useOsmdRenderer(previewXml, {zoom: 0.6});

const canPreview = computed(() => !!previewXml.value);

onMounted(async () => {
  try {
    const text = await historyStore.getText(entryId);
    // Nur echtes (unkomprimiertes) MusicXML rendern – MXL/MIDI/PDF sind binär.
    if (text && text.trimStart().startsWith('<')) {
      previewXml.value = text;
    }
  } finally {
    isLoading.value = false;
  }
});

</script>

<template>

  <!-- Vorschau -->
  <div class="">
    <h3 class="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-400">Vorschau</h3>
    <div class="rounded-lg border border-gray-200 bg-gray-50/40 p-2">
      <div v-if="isLoading" class="flex items-center justify-center gap-2 py-8 text-sm text-gray-400">
        <Icon icon="fa6-solid:spinner" class="animate-spin"/>
        Lädt…
      </div>
      <div v-else-if="!canPreview" class="flex items-center justify-center gap-2 py-8 text-sm text-gray-400">
        <Icon icon="fa6-solid:eye-slash"/>
        Keine Notenvorschau für dieses Format verfügbar.
      </div>
      <template v-else>
        <div v-if="isRendering" class="flex items-center justify-center gap-2 py-2 text-xs text-gray-400">
          <Icon icon="fa6-solid:spinner" class="animate-spin"/>
          Wird gerendert…
        </div>
        <p v-if="renderError" class="px-2 py-4 text-center text-sm text-red-500">
          Vorschau fehlgeschlagen: {{ renderError }}
        </p>
        <div ref="containerRef" class="max-h-[40dvh] overflow-auto"/>
      </template>
    </div>
  </div>

</template>
